<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>用户操作</span>
        </div>
        <el-form ref="queryForm2" onsubmit="return false" :model="queryParams2" :inline="true">
          <el-form-item label="用户" prop="uid">
            <el-autocomplete
              v-model="uid"
              popper-class="my-autocomplete"
              placeholder="UID/昵称/邮箱/手机号"
              :fetch-suggestions="querySearchAsync"
              clearable
              size="small"
              @select="handleSelect"
              @keyup.enter.native="handleKeyUp"
              @change="handleChange"
            >
              <template slot-scope="{ item }">
                <div class="name">UID:{{ item.value }} 昵称:{{ item.nick }}</div>
                <span class="addr">最后登录:{{ item.lasttime }}</span>
              </template>
            </el-autocomplete>

            <el-form-item v-if="userInfo.uid > 0">
              <!--              <el-button type="primary" icon="el-icon-search" size="mini" onsubmit="return false" @click="handleKeyUp">查询</el-button>-->
              <el-button style="margin-left: 10px" size="mini" type="primary" @click="dialogVisible[0].visible=true">设置等级</el-button>
              <el-button size="mini" type="primary" @click="dialogVisible[1].visible=true">资产操作</el-button>
              <el-button size="mini" type="primary" @click="dialogVisible[3].visible=true">+Vip积分</el-button>
              <el-button size="mini" type="primary" @click="dialogVisible[2].visible=true">+道具</el-button>
              <el-button size="mini" type="primary" @click="dialogVisible[4].visible=true">道具列表</el-button>
              <el-button size="mini" type="primary" @click="dialogVisible[5].visible=true">+卡片</el-button>
              <el-button size="mini" type="primary" @click="cardInfo()">卡片数据</el-button>
              <!--              <el-button size="mini" type="primary" @click="dialogVisible[6].visible=true">卡片数据</el-button>-->
              <el-button size="mini" type="primary" @click="dialogVisible[7].visible=true">好友管理</el-button>
              <!--              <el-button size="mini" type="primary" @click="dialogVisible[8].visible=true">重置管理</el-button>-->
              <el-button size="mini" type="primary" @click="beastInfo(1)">野兽数据</el-button>
              <el-button size="mini" type="primary" @click="beastInfo(2)">骰子数据</el-button>
              <el-button size="mini" type="primary" @click="beastInfo(3)">盾牌数据</el-button>
              <el-button size="mini" type="primary" @click="gotoreward(userInfo.uid)">用户流水</el-button>
              <el-button size="mini" type="primary" @click="gotoreward2(userInfo.uid)">用户流水折现图</el-button>
              <el-button size="mini" type="primary" @click="gotoevent(userInfo.uid)">用户事件流</el-button>
              <!--                            <el-button v-if="env !== 'production'" :loading="loading" size="mini" type="danger" @click="delUser()">删除</el-button>-->
              <el-button :loading="loading" size="mini" type="danger" @click="delUser()">删除</el-button>
            </el-form-item>
          </el-form-item>
          <el-form-item v-if="userInfo.uid <= 0">
            <el-tooltip placement="right-end">
              <div slot="content">邮箱:例如 123@gmail.com<br>手机号: 例如 +1-123456789 只需输入 123456789 不支持模糊搜索</div>
              <i class="el-icon-warning-outline" />
            </el-tooltip>
          </el-form-item>
        </el-form>

        <el-card v-if="userInfo.uid > 0">
          <div slot="header" class="clearfix">
            <span>基本信息</span>
          </div>
          <el-descriptions border>
            <el-descriptions-item :span="3" label="玩家头像">
              <el-image
                style="width: 100px; height: 100px"
                :src="isNumeric(userInfo.s_picture) ? '/static/games_avatar/u_headImg'+userInfo.s_picture+'.png' : userInfo.s_picture"
              />
            </el-descriptions-item>
            <el-descriptions-item label="玩家昵称">{{ userInfo.nick }}</el-descriptions-item>
            <el-descriptions-item label="玩家uid">
              <a href="#" class="underline" style="margin-right: 10px;" @click="gotoreward(userInfo.uid)">{{ userInfo.uid }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="是否在线">
              <el-tag v-if=" userInfo.isOnline > 0" type="success">在线</el-tag>
              <el-tag v-else type="info">离线</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="注册来源">{{ userInfo.reg_source }}</el-descriptions-item>
            <el-descriptions-item label="是否FB">{{ userInfo.isFb === 1 ?'是':'否' }}</el-descriptions-item>
            <el-descriptions-item label="是否机器人">{{ userInfo.isRobot > 0 ? '是' : '否' }}</el-descriptions-item>
            <el-descriptions-item label="登录平台	">
              <span v-if="userInfo.login_plat === 1">安卓</span>
              <span v-if="userInfo.login_plat === 2">IOS</span>
              <span v-if="userInfo.login_plat === 3">TG</span>
            </el-descriptions-item>
            <el-descriptions-item label="邮箱">{{ userInfo.email }}</el-descriptions-item>
            <el-descriptions-item label="绑定手机">{{ userInfo.phone }}</el-descriptions-item>
            <el-descriptions-item label="注册时间">{{ userInfo.createtime }}</el-descriptions-item>
            <el-descriptions-item label="最后登录时间">{{ userInfo.lasttime }}</el-descriptions-item>
            <el-descriptions-item label="登录天数">{{ userInfo.loginDays }}</el-descriptions-item>
            <el-descriptions-item label="VIP等级">{{ userInfo.vipLv > 0 ? userInfo.vipLv:'-' }}</el-descriptions-item>
            <el-descriptions-item label="VIP积分"> <span v-if="userInfo.vipLv > 0">{{ userInfo.vipPoint }}</span> </el-descriptions-item>
            <el-descriptions-item label="过期时间">{{ userInfo.vip_expire }}) </el-descriptions-item>
            <el-descriptions-item label="在线时长">{{ convertTime(userInfo.loginTime.toFixed(2)) }}</el-descriptions-item>
            <el-descriptions-item :span="2" label="平均在线">{{ userInfo.onlineAvg.toFixed(2) }}分钟</el-descriptions-item>
            <el-descriptions-item label="邀请人">{{ userInfo.inviteuid }}</el-descriptions-item>
            <el-descriptions-item label="邀请人数">{{ userInfo.invite_number }}</el-descriptions-item>
            <el-descriptions-item label="好友数量">{{ userInfo.friendNumber }} (机器人:{{ userInfo.robotNumber }})</el-descriptions-item>
            <el-descriptions-item label="国家">{{ country[userInfo.address.country_code] }}</el-descriptions-item>
            <el-descriptions-item label="当前版本">{{ userInfo.version }}</el-descriptions-item>
            <el-descriptions-item label="关卡等级">{{ userInfo.build_level }}</el-descriptions-item>
            <el-descriptions-item label="俱乐部">{{ userInfo.clubName }}</el-descriptions-item>
            <el-descriptions-item label="用户分组" :span="3">{{ userInfo.userGroupName }}</el-descriptions-item>
            <el-descriptions-item label="用户Token" :span="3">
              <span v-if="userInfo.token" class="el-icon-document-copy" @click="copyText(userInfo.token)">
                {{ userInfo.token }}
              </span>
              <span v-else>-</span>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>

        <el-card v-if="userInfo.uid > 0">
          <div slot="header" class="clearfix">
            <span>充值信息</span>
          </div>
          <el-descriptions border>
            <el-descriptions-item label="充值总额">${{ userInfo.sumMoney }}</el-descriptions-item>
            <!--            <el-descriptions-item label="付费率">${{ userInfo.todayRecharge }}</el-descriptions-item>-->
            <el-descriptions-item :spa="2" label="今日充值">${{ userInfo.todayRecharge }}</el-descriptions-item>
          </el-descriptions>
        </el-card>

        <el-card v-if="userInfo.uid > 0">
          <div slot="header" class="clearfix">
            <span>资产信息</span>
          </div>
          <el-descriptions border>
            <el-descriptions-item label="当天消耗金币">{{ userInfo.todayCostMoney }}</el-descriptions-item>
            <el-descriptions-item label="当天获得金币">{{ userInfo.todayMoney }}</el-descriptions-item>
            <el-descriptions-item label="当天消耗体力">{{ userInfo.todayCostSpins }}</el-descriptions-item>
            <el-descriptions-item label="当天获得体力">{{ userInfo.todaySpins }}</el-descriptions-item>
            <el-descriptions-item label="玩家金币">
              <a class="underline" href="javascript:;" @click="queryMoney(14)">{{ scientificFormat(userInfo.money) }}</a>
              <i class="el-icon-s-data sourceStat" @click="querySourceStat(14)" />
            </el-descriptions-item>
            <el-descriptions-item label="玩家钻石">
              <a class="underline" href="javascript:;" @click="queryMoney(22)">{{ scientificFormat(userInfo.diamond) }}</a>
              <i class="el-icon-s-data sourceStat" @click="querySourceStat(22)" />
            </el-descriptions-item>
            <el-descriptions-item label="玩家野兽币">
              <a class="underline" href="javascript:;" @click="queryMoney(65)">{{ scientificFormat(userInfo.beastCoin) }}</a>
              <i class="el-icon-s-data sourceStat" @click="querySourceStat(65)" />
            </el-descriptions-item>
            <el-descriptions-item label="玩家盾牌">
              <a class="underline" href="javascript:;" @click="queryMoney(16)">{{ userInfo.shield }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="玩家体力">
              <a class="underline" href="javascript:;" @click="queryMoney(15)">{{ scientificFormat(userInfo.spins) }}</a>
              <i class="el-icon-s-data sourceStat" @click="querySourceStat(15)" />
            </el-descriptions-item>
            <el-descriptions-item label="每天平均消耗体力">{{ userInfo.spinsAvg }}</el-descriptions-item>
            <el-descriptions-item :span="2" label="玩家星星数">
              <a class="underline" href="javascript:;" @click="queryMoney(42)">{{ scientificFormat(userInfo.star) }}</a>
            </el-descriptions-item>
            <el-descriptions-item label="当天体力RTP">
              <el-tooltip placement="top">
                <div slot="content">当天体力RTP= 当天消耗/当天发放 *100%</div>
                <button style="border: none;background: #fff" class="el-icon-warning-outline"> {{ userInfo.rtp }}%</button>
              </el-tooltip>
            </el-descriptions-item>
            <el-descriptions-item label="当天升级速率">
              <el-tooltip placement="top">
                <div slot="content">当天升级速率=升级关卡数/天数</div>
                <button style="border: none;background: #fff" class="el-icon-warning-outline"> {{ userInfo.upgrade_rate }}</button>
              </el-tooltip>
            </el-descriptions-item>
          </el-descriptions>
        </el-card>
        <!--        +-金币-->
        <el-dialog
          title="资产操作"
          :visible.sync="dialogVisible[1].visible"
          width="400px"
          :before-close="(d)=>handleClose(d,1)"
        >
          <el-form class="demo-form-inline">
            <el-form-item label="发奖原因">
              <el-select v-model.number="actUserParams.rewardType" filterable placeholder="请选择">
                <el-option
                  v-for="item in ridType2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="金币数">
              <el-input v-model.number="actUserParams.coins" style="width: 300px;" placeholder="直接填写数字,减钱添加负号即可,不填则不更改" />
            </el-form-item>
            <el-form-item>
              <el-button size="mini" style="margin-left: 5px" @click="addCoin(1)">1W</el-button>
              <el-button size="mini" style="margin-left: 5px" @click="addCoin(2)">10W</el-button>
              <el-button size="mini" style="margin-left: 5px" @click="addCoin(3)">1M</el-button>
              <el-button size="mini" style="margin-left: 5px" @click="addCoin(4)">10M</el-button>
              <el-button size="mini" style="margin-left: 5px" @click="addCoin(5)">50M</el-button>
              <el-button size="mini" style="margin-left: 5px" @click="addCoin(6)">100M</el-button>
            </el-form-item>
            <el-form-item label="体力数">
              <el-input v-model.number="actUserParams.spins" style="width: 300px;" placeholder="直接填写数字,减钱添加负号即可,不填则不更改" />
            </el-form-item>
            <el-form-item label="盾牌数">
              <el-input v-model.number="actUserParams.shield" style="width: 300px;" placeholder="直接填写数字,减钱添加负号即可,不填则不更改" />
            </el-form-item>
            <el-form-item label="星星数">
              <el-input v-model.number="actUserParams.star" style="width: 300px;" placeholder="直接填写数字,减钱添加负号即可,不填则不更改" />
            </el-form-item>
            <el-form-item label="钻石">
              <el-input v-model.number="actUserParams.diamond" style="width: 300px;" placeholder="直接填写数字,减钱添加负号即可,不填则不更改" />
            </el-form-item>
            <el-form-item label="野兽币">
              <el-input v-model.number="actUserParams.beastCoin" style="width: 300px;" placeholder="直接填写数字,减钱添加负号即可,不填则不更改" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[1].visible= false">取 消</el-button>
            <el-button type="primary" @click="userChange(1)">确 定</el-button>
          </span>
        </el-dialog>

        <!--        +-金币-->

        <!--        +-道具-->
        <el-dialog
          title="道具操作"
          :visible.sync="dialogVisible[2].visible"
          width="580px"
          :before-close="(v)=>handleClose(d,2)"
        >
          <el-form class="demo-form-inline">
            <el-form :inline="true">
              <el-row v-for="(item, index) in actUserParams.prop" :key="index">
                <el-form-item label="道具">
                  <el-select v-model="item.propId" style="width: 230px" placeholder="请选择" @change="selectPropEvent">
                    <el-option
                      v-for="item in rewardType2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数量">
                  <el-input v-model.number="item.num" style="width: 100px;" placeholder="数量" />
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="delProp(index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-button type="primary" @click="addProp">+</el-button>
            </el-form>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[2].visible=false">取 消</el-button>
            <el-button type="primary" @click="userChange(3)">确 定</el-button>
          </span>
        </el-dialog>
        <!--        +-道具-->

        <!--        +-等级-->
        <el-dialog
          title="等级操作"
          :visible.sync="dialogVisible[0].visible"
          width="500px"
          :before-close="v=>handleClose(v,0)"
        >
          <el-form class="demo-form-inline" :inline="true">
            <el-form-item label="选择等级类型">
              <el-select v-model="actUserParams.levelType" style="width: 120px" placeholder="请选择" @change="selectPropEvent">
                <el-option
                  v-for="item in levelType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="新等级">
              <el-input v-model.number="actUserParams.level" style="width: 120px;" placeholder="新等级" />
            </el-form-item>
            <el-form-item v-if="actUserParams.levelType === 1" label="vip过期时间">
              <el-date-picker
                v-model="actUserParams.vipExperienceLv"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[0].visible=false">取 消</el-button>
            <el-button type="primary" @click="userChange(2)">确 定</el-button>
          </span>
        </el-dialog>
        <!--        +-等级-->

        <!--        +-vip积分-->
        <el-dialog
          title="Vip积分操作"
          :visible.sync="dialogVisible[3].visible"
          width="400px"
          :before-close="v=>handleClose(v,3)"
        >
          <el-form class="demo-form-inline">
            <el-form-item label="Vip积分">
              <el-input v-model.number="actUserParams.score" style="width: 300px;" placeholder="Vip积分" />
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[3].visible=false">取 消</el-button>
            <el-button type="primary" @click="userChange(4)">确 定</el-button>
          </span>
        </el-dialog>
        <!--        +-vip积分-->

        <!--        +-道具列表-->
        <el-dialog
          title="道具列表"
          :visible.sync="dialogVisible[4].visible"
          width="450px"
          :before-close="v=>handleClose(v,4)"
          @open="getProp"
        >
          <el-form class="demo-form-inline">
            <el-form :inline="true">
              <el-row v-for="(item, index) in props" :key="index">
                <el-form-item label="道具">
                  <el-input v-model="item.name" readonly style="width: 100px;" placeholder="道具" />
                </el-form-item>
                <el-form-item label="数量">
                  <el-input v-model="item.num" style="width: 100px;" placeholder="数量" />
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="delBagProp(item.id)">删除</el-button>
                </el-form-item>
              </el-row>
            </el-form>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[4].visible=false">取 消</el-button>
            <el-button type="primary" @click="changePropNum">确 定</el-button>
          </span>
        </el-dialog>
        <!--        +-道具列表-->

        <!--        +-卡片-->
        <el-dialog
          title="+卡片"
          :visible.sync="dialogVisible[5].visible"
          width="680px"
          :before-close="v=>handleClose(v,5)"
        >
          <el-form class="demo-form-inline">
            <el-form :inline="true">
              <el-row v-for="(item, index) in actUserParams.card" :key="index">
                <el-form-item label="分组">
                  <el-select v-model="item.cardGid" style="width: 120px" placeholder="请选择" @change="(v)=>selectCardGroupEvent(v, index)">
                    <el-option
                      v-for="item in cardGroup"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="卡片">
                  <el-select v-model="item.cardId" style="width: 120px" placeholder="请选择">
                    <el-option
                      v-for="item in cards[index]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="item.disabled"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="数量">
                  <el-input v-model="item.num" style="width: 100px;" placeholder="数量" />
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="delCard(index)">删除</el-button>
                </el-form-item>
              </el-row>
              <el-button type="primary" @click="addCard()">+</el-button>
            </el-form>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[5].visible=false">取 消</el-button>
            <el-button type="primary" @click="userChange(6)">确 定</el-button>
          </span>
        </el-dialog>
        <!--        +-卡片-->

        <!--        +-卡片列表-->
        <el-dialog
          title="卡片数据"
          :visible.sync="dialogVisible[6].visible"
          width="550px"
          :before-close="v=>handleClose(v,6)"
          @open="getUserCard"
        >
          <el-form class="demo-form-inline" style="overflow: auto;height: 400px">
            <el-form :inline="true">
              <el-row v-for="(item, index) in userCards" :key="index">
                <el-form-item label="卡片">
                  <el-input v-model="item.name" readonly style="width: 200px;" placeholder="道具" />
                <!--                <span>{{ item.name }}</span>-->
                </el-form-item>
                <el-form-item label="数量">
                  <el-input v-model="item.num" style="width: 100px;" placeholder="数量" />
                </el-form-item>
                <el-form-item>
                  <el-button type="danger" @click="delBagCard(item.ciid)">删除</el-button>
                </el-form-item>
              </el-row>
            </el-form>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[6].visible=false">取 消</el-button>
            <el-button v-if="userCards.length > 0" type="primary" @click="changCardNum()">确 定</el-button>
          </span>
        </el-dialog>
        <!--        +-卡片列表-->

        <!--        +-野兽列表-->
        <el-dialog
          :title="beastTitle"
          :visible.sync="dialogVisible[9].visible"
          width="600px"
          :before-close="v=>handleClose(v,9)"
        >
          <div style="overflow:auto;height: 400px">
            <prodTable ref="prodTable" />
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[9].visible=false">取 消</el-button>
          <!--          <el-button>确 定</el-button>-->
          </span>
        </el-dialog>
        <!--        +-野兽列表-->

        <!--        +-卡片数据-->
        <el-dialog
          title="卡组数据"
          :visible.sync="dialogVisible[10].visible"
          width="1500px"
          :before-close="v=>handleClose(v,10)"
        >
          <div style="overflow:auto;height: 600px">
            <cardInfo ref="cardInfo" />
          </div>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible[10].visible=false">取 消</el-button>
          <!--          <el-button>确 定</el-button>-->
          </span>
        </el-dialog>
        <!--        +-卡片数据-->

        <!--        +-好友管理-->
        <el-dialog
          title="好友管理"
          :visible.sync="dialogVisible[7].visible"
          width="650px"
          :before-close="v=>handleClose(v,7)"
          @open="getFriend"
        >
          <template>
            <el-form ref="queryForm3" :model="queryParams3" :inline="true" label-width="100px">
              <el-form-item label="用户ID" prop="uid">
                <el-input
                  v-model.number="queryParams3.uid"
                  placeholder="请输入用户ID"
                  clearable
                  size="small"
                  @keyup.enter.native="addFriend"
                />
              </el-form-item>
              <el-button style="margin-top: 5px" size="mini" type="primary" @click="addFriend">添加</el-button>
            </el-form>

            <el-tabs v-model="activeName" style="overflow: auto;height: 400px" @tab-click="handleClick">
              <el-tab-pane label="游戏好友" name="first">
                <template>
                  <el-table
                    :data="userList"
                    border
                    style="width: 100%"
                  >
                    <el-table-column
                      label="用户ID"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.uid }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="昵称"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.nick }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="是否机器人"
                      align="center"
                    >
                      <template slot-scope="scope">
                        <span v-if=" scope.row.is_bot">是</span>
                        <span v-else>否</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      align="center"
                      label="操作"
                    >
                      <template slot-scope="scope">
                        <el-button type="warning" size="small" @click="blackFriend(scope.row.uid)">拉黑</el-button>
                        <el-button type="danger" size="small" @click="delFriend(scope.row.uid,1)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </el-tab-pane>
              <el-tab-pane label="拉黑好友" name="second">
                <el-table
                  :data="userList"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    label="用户ID"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.uid }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="昵称"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.nick }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="是否机器人"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span v-if=" scope.row.is_bot">是</span>
                      <span v-else>否</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <!--                    <el-button type="warning" size="small" @click="handleClick(scope.row)">拉黑</el-button>-->
                      <el-button type="danger" size="small" @click="delFriend(scope.row,4)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-tab-pane>
              <el-tab-pane label="FB" name="third">
                <el-table
                  :data="userList"
                  border
                  style="width: 100%"
                >
                  <el-table-column
                    label="用户ID"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.uid }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="昵称"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.nick }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作"
                  >
                    -
                  </el-table-column>
                </el-table></el-tab-pane>
            </el-tabs>
          </template>
        <!--        <span slot="footer" class="dialog-footer">-->
        <!--          <el-button @click="dialogVisible[7].visible=false">取 消</el-button>-->
        <!--          <el-button type="primary" @click="changePropNum">确 定</el-button>-->
        <!--        </span>-->
        </el-dialog>
        <!--        +-好友管理-->

        <!--      <el-dialog-->
        <!--        title="重置管理"-->
        <!--        :visible.sync="dialogVisible[8].visible"-->
        <!--        width="650px"-->
        <!--        :before-close="v=>handleClose(v,8)"-->
        <!--        @open="getFriend"-->
        <!--      >1</el-dialog>-->

      </el-card></template>
  </BasicLayout>
</template>

<script>
import {
  changeUserAsset,
  deleteUid,
  searchUid,
  getPropList,
  getCardList,
  getUserFriendList,
  getUserBeast, getUserSieve, getUserShield, getUserCard
} from '@/api/user/user_info'
import { getRewardType } from '@/api/config/slot'
import { getRewardRecordList, getRidTypeList } from '@/api/config/reward-record'
import { getCardGroupList } from '@/api/config/card-pro'
import { getCardCfgList } from '@/api/config/card-cfg'
import { isNumeric } from 'echarts/lib/util/number'
import { CurDate } from '@/api/date'
import { convertTime, scientificFormat } from '@/utils'
import prodTable from '@/views/config/user/components/prod-table.vue'
import cardInfo from '@/views/config/user/components/card-info.vue'
export default {
  name: 'User',
  components: {
    prodTable,
    cardInfo
  },
  data() {
    return {
      uid: '',
      userList: [],
      activeName: 'first',
      env: process.env.VUE_APP_ENV,
      queryParams2: {
        uid: ''
      },
      userInfo: {

      },
      country: {},
      queryParams3: {
        uid: '',
        act: 1
      },
      actUserParams: {
        type: 1,
        nowCoins: 0,
        coins: 0,
        spins: 0,
        shield: 0,
        star: 0,
        levelType: 2,
        level: 0,
        vipExperienceLv: '',
        prop: [],
        card: [],
        uid: 0,
        score: 0,
        ciid: 0,
        actUid: 0,
        act: 1,
        diamond: 0,
        beastCoin: 0,
        rewardType: 999
      },
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        uid: '',
        time: '',
        rid: '',
        type: ''
      },
      loading: false,
      total: 0,
      options: [],
      formData: {
        uid: 0,
        createtime: 0,
        version: ''
      },
      beastTitle: '野兽数据',
      tableData: [],
      rewardType: [],
      rewardType2: [],
      box: [1, 2, 3, 19],
      ridType: [],
      ridType2: [{ label: '后台修改', value: 999 }, { label: '系统补偿', value: 997 }],
      levelType: [{ label: '关卡等级', value: 2 }, { label: 'vip等级', value: 1 }],
      dialogVisible: [
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false },
        { visible: false }
      ],
      props: [],
      notCloseType: [4, 6], // 不关闭的静态框 index,
      cardGroup: [],
      cards: [],
      userCards: []
    }
  },
  created() {
    this.getRidTypeData()
    this.getRewardTypeData()
    let getUid = this.$route.query.uid
    if (!getUid) {
      getUid = this.$store.state.queryForm.searchUid
    }
    if (getUid > 0) {
      this.queryParams2.uid = getUid
      this.onSubmit()
    } else {
      const cache = sessionStorage.getItem('UserInfoUid')
      if (cache != null) {
        this.uid = this.queryParams2.uid = parseInt(cache)
      }
    }
    if (this.uid) {
      this.onSubmit()
    }
    this.getCardGrouData()
    this.selectCardGroupEvent()
  },
  methods: {
    convertTime,
    scientificFormat,
    fetchData() {
      const searchUid = this.$store.state.queryForm.searchUid
      if (searchUid > 0) {
        this.queryParams2.uid = searchUid
        this.onSubmit()
      }
    },
    beforeDestroy() {
      this.$root.$off('fetchData', this.fetchData) // 取消监听 fetchData 事件
    },
    handleSelect(item) {
      this.queryParams2.uid = parseInt(item.value)
      this.onSubmit()
    },
    querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      const queryStr = parseInt(queryString)
      const results = []
      let query = {}
      if (isNaN(queryStr)) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (emailRegex.test(queryString)) {
          query = { data: queryString }
        } else {
          query = { name: queryString }
        }
      } else {
        if (queryString.length >= 8) {
          query = { phone: queryString }
        } else {
          query = { id: queryStr }
        }
      }
      searchUid(query).then(res => {
        if (res.code === 200) {
          res.data.data.forEach(item => {
            results.push({ value: item.uid, nick: item.nick, lasttime: item.lasttime })
          })

          if (results.length) {
            cb(results)
          } else {
            this.userInfo = { uid: 0 }
          }
        }
      })
    },
    handleChange(value) {
      if (!value && this.userInfo) {
        this.userInfo = { uid: 0 }
      }
    },
    handleClick(tab, event) {
      const idx = parseInt(tab.index) + 1
      this.getUserFriend(idx)
    },
    getUserFriend(idx) {
      getUserFriendList({ uid: this.actUserParams.uid, type: idx }).then(res => {
        if (res.code === 200) {
          this.userList = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    isNumeric,
    handleUserFriend(type, uid) {

    },
    userChange(type) {
      if (!this.queryParams2.uid) {
        this.msgError('uid有误,提交失败!')
        return
      }
      this.dialogVisibleChange()
      this.actUserParams.type = type
      const data = Object.assign({}, this.actUserParams)

      if (type === 2) {
        if (this.actUserParams.level <= 0) {
          this.msgError('等级必须大于0')
          return
        }
        if (this.actUserParams.levelType === 1 && this.actUserParams.vipExperienceLv === '') {
          this.msgError('请选择过期时间')
          return
        }
      }
      if (type === 3) {
        if (this.actUserParams.prop.length <= 0) {
          this.msgError('无可提交数据')
          return
        }
        for (const i in this.actUserParams.prop) {
          const val = this.actUserParams.prop[i]
          if (val.num === 0) {
            this.msgError('道具数量不能等于0')
            return
          }
        }
      }

      if (type === 8) {
        data.actUid = this.queryParams3.uid
        data.act = this.queryParams3.act
        this.queryParams3.uid = ''
        this.queryParams3.act = 1
      }
      data.prop = JSON.stringify(data.prop)
      data.card = JSON.stringify(data.card)

      changeUserAsset(data).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.onSubmit()
          this.actUserParams = {
            type: 0,
            nowCoins: 0,
            coins: 0,
            spins: 0,
            shield: 0,
            star: 0,
            diamond: 0,
            beastCoin: 0,
            level: 0,
            levelType: 2,
            vipExperienceLv: '',
            score: 0,
            uid: this.actUserParams.uid,
            card: [],
            prop: [],
            ciid: 0,
            actUid: 0,
            act: 1,
            rewardType: 999
          }

          if (type === 5) {
            this.getProp()
          }

          if (type === 7) {
            this.getUserCard()
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    dialogVisibleChange() {
      this.dialogVisible.forEach((item, index) => {
        if (!this.notCloseType.includes(index)) {
          this.dialogVisible[index].visible = false
        }
      })
    },
    addCoin(index) {
      let coins = 0
      switch (index) {
        case 1:
          coins = 10000
          break

        case 2:
          coins = 100000
          break

        case 3:
          coins = 1000000
          break

        case 4:
          coins = 10000000
          break

        case 5:
          coins = 50000000
          break

        case 6:
          coins = 100000000
          break
      }

      this.actUserParams.coins = coins
    },
    handleClose(d, act) {
      if (act === 7) {
        this.activeName = 'first'
      }
      this.dialogVisible[act].visible = false
    },
    typeFormatter(row, column) {
      let typeName = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === row.type) {
          typeName = val.label
          break
        }
      }
      return typeName
    },
    ridFormatter(row, column) {
      let ridName = ''
      for (const i in this.ridType) {
        const val = this.ridType[i]
        if (val.value === row.type) {
          ridName = val.label
          break
        }
      }
      return ridName
    },
    getFriend() {
      this.getUserFriend(1)
    },
    addFriend() {
      const uid = parseInt(this.queryParams3.uid)
      if (!uid) {
        this.msgError('用户UID有误!')
        return
      }
      this.queryParams3.act = 3
      this.userChange(8)
    },
    delFriend(actUid, typ) {
      let text = '此操作将删除该好友, 是否继续'
      if (typ === 4) {
        text = '此操作将移除该好友, 是否继续'
      }
      this.$confirm(`${text}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.queryParams3.uid = actUid
        this.queryParams3.act = typ
        this.userChange(8)
      })
    },
    blackFriend(actUid) {
      this.queryParams3.uid = actUid
      this.queryParams3.act = 2
      this.userChange(8)
    },
    handleKeyUp() {
      this.onSubmit()
    },
    onSubmit() {
      if (this.queryParams2.uid === '') {
        this.msgError('请选择用户UID')
        return
      }
      const uid = parseInt(this.queryParams2.uid)
      if (uid <= 0 || isNaN(uid)) {
        this.queryParams2.uid = ''
        this.msgError('UID不正确')
        return
      }
      sessionStorage.setItem('UserInfoUid', uid + '')
      this.$store.dispatch('queryForm/userSearchForm', {
        uid: uid
      })
      searchUid({ id: uid }).then(res => {
        if (res.code === 200) {
          this.uid = uid
          this.userInfo = []
          this.country = {}
          this.queryParams.uid = 0
          if (res.data.data.length > 0) {
            this.formData.createtime = res.data.data[0].createtime
            this.formData.version = res.data.data[0].version
            this.formData.uid = res.data.data[0].uid
            this.userInfo = res.data.data[0]
            this.country = res.data.country
            this.queryParams.uid = uid
            this.actUserParams.uid = uid
          } else {
            this.msgError('账号不存在')
          }
        } else {
          this.msgError('查询失败')
        }
      })
    },
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },
    handleQuery() {
      if (this.queryParams.time === '') {
        this.msgError('请选择日期')
        return
      }
      this.getTables()
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const id = parseInt(i)
            this.rewardType.push({ 'label': res.data[i], 'value': id })
            if (this.box.includes(id)) {
              this.rewardType2.push({ 'label': res.data[i], 'value': id, disabled: false })
            }
          }
        }
      })
    },
    getRidTypeData() {
      getRidTypeList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.ridType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    delUser() {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        deleteUid({ id: this.formData.uid }).then(res => {
          if (res.code === 200) {
            this.formData = {
              uid: 0,
              createtime: 0,
              version: ''
            }
            this.userInfo.uid = 0
            this.queryParams.uid = 0
            this.actUserParams.uid = 0
            this.queryParams = {
              pageIndex: 1,
              pageSize: 10,
              uid: '',
              time: '',
              rid: '',
              type: ''
            }
            this.loading = false
            this.msgSuccess(res.msg)
          } else {
            this.loading = false
            this.msgError(res.msg)
          }
        })
      })
    },
    getTables() {
      getRewardRecordList(this.queryParams).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addProp() {
      this.listenSeletProp()
      let selectProp = ''
      for (const i in this.rewardType2) {
        const prop = this.rewardType2[i]
        if (!prop.disabled) {
          selectProp = prop.value
          break
        }
      }

      if (!selectProp) {
        this.msgError('无可选道具')
        return
      }

      this.actUserParams.prop.push({
        add: 1,
        propId: selectProp,
        num: 1
      })
      this.listenSeletProp()
    },
    delProp(i) {
      this.actUserParams.prop = this.actUserParams.prop.filter((item, index) => {
        return index !== i
      })
      this.listenSeletProp()
    },
    selectPropEvent() {
      this.listenSeletProp()
    },
    listenSeletProp() {
      this.rewardType2.forEach((item, index) => {
        this.rewardType2[index].disabled = false
      })

      this.actUserParams.prop.forEach(item => {
        for (const i in this.rewardType2) {
          const prop = this.rewardType2[i]
          if (prop.value === item.propId) {
            this.rewardType2[i].disabled = true
          }
        }
      })
    },
    delBagProp(id) {
      this.actUserParams.propId = id
      this.$confirm('此操作将永久删除该道具, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.userChange(5)
      })
    },
    getProp() {
      getPropList({ id: this.actUserParams.uid }).then(res => {
        if (res.code === 200) {
          this.props = []
          if (res.data.length > 0) {
            res.data.forEach(item => {
              const propName = this.findPropName(item.id)
              this.props.push({ name: propName, num: item.count, id: item.id })
            })
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    findPropName(type) {
      let propName = ''
      for (const i in this.rewardType) {
        const val = this.rewardType[i]
        if (val.value === type) {
          propName = val.label
          break
        }
      }
      return propName
    },
    getCardGrouData() {
      getCardGroupList({ name: 'first' }).then(res => {
        if (res.code === 200) {
          res.data.forEach(item => {
            this.cardGroup.push({ label: item.cg_name, value: item.cgid })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getUserCard() {
      getCardList({ id: this.actUserParams.uid }).then(res => {
        if (res.code === 200) {
          if (res.data !== null) {
            this.userCards = res.data
          }
        } else {
          this.msgError(res.msg)
        }
      })
    },
    selectCardGroupEvent(gid = 0, index) {
      getCardCfgList({ pageIndex: 1, pageSize: 1000, cgid: gid }).then(res => {
        if (res.code === 200) {
          if (!Object.prototype.hasOwnProperty.call(this.cards, index)) {
            this.$set(this.cards, index, [])
          }
          this.cards[index] = []
          res.data.list.forEach(res => {
            this.cards[index].push({ label: res.ci_name, value: res.ciid })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addCard() {
      this.actUserParams.card.push({ cardGid: 0, cardId: 1, num: 1 })
      const len = this.actUserParams.card.length - 1
      this.selectCardGroupEvent(0, len)
    },
    delCard(index) {
      this.actUserParams.card = this.actUserParams.card.filter((item, i) => {
        return index !== i
      })
    },
    delBagCard(ciid) {
      this.actUserParams.ciid = ciid
      this.userChange(7)
    },
    changePropNum() {
      this.actUserParams.prop = []
      this.props.forEach(item => {
        this.actUserParams.prop.push({
          add: -1,
          propId: item.id,
          num: item.num
        })
      })
      this.userChange(3)
    },
    changCardNum() {
      this.actUserParams.card = []
      this.userCards.forEach(item => {
        this.actUserParams.card.push({ cardGid: -1, cardId: item.ciid, num: item.num })
      })
      this.userChange(6)
    },
    gotoreward(uid) {
      this.$router.push({ name: 'RewardRecord', query: { uid: uid }})
    },
    gotoreward2(uid) {
      this.$router.push({ name: 'UserRewardStat', query: { uid: uid }})
    },
    gotoevent(uid) {
      sessionStorage.setItem('EventFlow', JSON.stringify({ pageIndex: 1, pageSize: 15, id: uid, date: CurDate() }))
      this.$router.push({ name: 'eventflow', query: {}})
    },
    copyText(textToCopy) {
      const input = document.createElement('textarea')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      input.value = textToCopy
      document.body.appendChild(input)
      input.focus()
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('文本已复制到剪贴板')
    },
    queryMoney(type) {
      this.$router.push({ name: 'RewardRecordV2', query: { uid: this.queryParams.uid, type: type }})
    },
    querySourceStat(type) {
      this.$router.push({ name: 'CurrencySources', query: { uid: this.queryParams.uid, type: type }})
    },
    beastInfo(typ) {
      const arr = ['野兽数据', '骰子数据', '盾牌数据']
      this.beastTitle = arr[typ - 1]
      this.dialogVisible[9].visible = true
      this.getUserBeastData(typ)
    },
    getUserBeastData(typ) {
      switch (typ) {
        case 1:
          getUserBeast({ id: this.actUserParams.uid }).then(res => {
            this.$refs.prodTable.init(res.data, 0)
          })
          break
        case 2:
          getUserSieve({ id: this.actUserParams.uid }).then(res => {
            this.$refs.prodTable.init(res.data, 1)
          })
          break
        case 3:
          getUserShield({ id: this.actUserParams.uid }).then(res => {
            this.$refs.prodTable.init(res.data, 2)
          })
          break
      }
    },
    cardInfo() {
      this.dialogVisible[10].visible = true
      getUserCard({ id: this.actUserParams.uid }).then(res => {
        this.$refs.cardInfo.init(res.data)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.underline{
  color: #0e6cff;
  text-decoration:underline;
  text-underline: #1c84c6;
}
.sourceStat{
  margin-left: 10px;
  cursor:pointer;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: black;
    }

    .highlighted .addr {
      color: black;
    }
  }
}
</style>
